import Head from 'next/head';
import { useLocalSettings } from '@/providers/LocalSettingsProvider';
import type { ReactNode } from 'react';
import Link from 'next/link';
import { DebugInfoReadout } from '../DebugInfoReadout';
interface SEOProps {
  canonical?: string;
  children?: ReactNode;
  description?: string;
  og?: {
    image?: string;
    url?: string;
  };
  title?: string;
}
export const defaultMetaTitle = 'Royalty-Free Music For Creators';
export const defaultMetaDescription = "Create your free Uppbeat account & start downloading the best copyright-free music from the world's hottest beatmakers.";
export const defaultOpenGraphImage = 'https://cdn.uppbeat.io/images-2025/og_landscape_2000_1046.jpg';
export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  children,
  canonical,
  og
}) => {
  const {
    localSettings
  } = useLocalSettings();
  const shouldShowSeoDebugger = localSettings.isShowSEOData;
  const metaTitle = title ?? defaultMetaTitle;
  const metaDescription = description ?? defaultMetaDescription;
  const opengraphImage = og?.image ?? defaultOpenGraphImage;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
        <title key="title">{metaTitle}</title>
        <meta content={metaDescription} key="description" name="description" data-sentry-element="meta" data-sentry-source-file="index.tsx" />

        <meta content={metaTitle} key="og:title" property="og:title" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        <meta content={metaDescription} key="og:description" property="og:description" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        {og?.url && <meta content={og.url} property="og:url" />}
        <meta content={opengraphImage} key="og:image" property="og:image" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        <meta content={opengraphImage} key="twitter:image" name="twitter:image" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        <meta content="Uppbeat" property="og:site_name" data-sentry-element="meta" data-sentry-source-file="index.tsx" />

        <meta content={metaTitle} key="twitter:title" name="twitter:title" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        <meta content={metaDescription} key="twitter:description" name="twitter:description" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        {canonical !== undefined && canonical !== '' && <link href={canonical} key="canonical" rel="canonical" />}
        {children}
      </Head>
      {!!shouldShowSeoDebugger && <DebugInfoReadout title="SEO Debugger" content={[{
      title: 'Title',
      value: metaTitle
    }, {
      title: 'Description',
      value: metaDescription
    }, {
      title: 'Opengraph Image',
      value: <Link href={opengraphImage} target="_blank" className="text-white underline">
                  {opengraphImage}
                </Link>
    }]} />}
    </>;
};